import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';

const ConfirmActionDialog = ({
	title = _e('are_you_sure'),
	message,
	loading,
	open,
	confirmLabel,
	handleClose,
	handleOK,
}) => {
	const renderContent = () => {
		return (
			<Box p={1}>
				<Typography variant="body1" gutterBottom>
					{message}
				</Typography>
			</Box>
		);
	};

	return (
		<GenericDialog
			open={open}
			loading={loading}
			handleClose={handleClose}
			content={renderContent()}
			title={title}
			showTitleDivider
			confirmButtonColor="primary"
			confirmButtonVariant="contained"
			confirmLabel={confirmLabel}
			confirmAction={handleOK}
		/>
	);
};

ConfirmActionDialog.propTypes = {
	open: PropTypes.bool,
	loading: PropTypes.bool,
	confirmLabel: PropTypes.string,
	handleClose: PropTypes.func,
	title: PropTypes.string,
	message: PropTypes.string,
	handleOK: PropTypes.func,
};

export default ConfirmActionDialog;
